import { Input } from 'antd';
import styled from 'styled-components';

export default styled(Input)`
	// Add your styles here
`;
